import React from 'react'

import { CTASection } from 'components/cta-section/CTASection'
import soundcoreLogo from 'shared/assets/logos/soundcore.svg'

import type { SoundcoreCtaCmsContent } from 'core/services/cms/interfaces'

import styles from './CTA.module.scss'


interface CTAProps {
  content: SoundcoreCtaCmsContent
}

const CTA: React.FC<CTAProps> = ({ content }) => {
  return (
    <CTASection
      logo={soundcoreLogo}
      logoAlt="Soundcore"
      text={content.text}
      backgroundImage={content.backgroundImageUrl}
      className={styles.cta}
    />
  )
}

export default CTA
